import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// @mui
import { Avatar, Checkbox, Chip, IconButton, Stack, TableBody, TableCell, TableRow, Typography } from '@mui/material';
// components
import Iconify from '../../../components/iconify';
import IntegrityBadge from '../../../components/IntegrityBadge';

SessionTableBody.propTypes = {
  sessions: PropTypes.array,
  selected: PropTypes.array,
  handleClick: PropTypes.func,
  handleOpenMenu: PropTypes.func,
  emptyRows: PropTypes.number,
  user: PropTypes.object,
};

function getDateString(dateAsString) {
  const date = new Date(dateAsString);
  const options = {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  };
  const formattedDateTime = date.toLocaleString('en-US', options);
  return formattedDateTime;
}

function SessionTableBody({ sessions, selected, handleClick, handleOpenMenu, emptyRows, user }) {
  const navigate = useNavigate();

  function onClicked(input, id) {
    const linkToNavigate = `/dashboard/session/${id}`;

    // move to the session page for the id
    navigate(linkToNavigate);
  }

  return (
    <TableBody>
      {sessions.map((row) => {
        const { id, name, startTime, description, lastModified, integrityStatus, ownerId } = row;
        const selectedSession = selected.indexOf(id) !== -1;
        return (
          <TableRow
            hover
            key={id}
            tabIndex={-1}
            role="checkbox"
            selected={selectedSession}
            aria-checked={selectedSession}
          >
            <TableCell padding="checkbox">
              <Checkbox checked={selectedSession} onChange={(event) => handleClick(event, id)} />
            </TableCell>
            <TableCell component="th" scope="row" padding="none" onClick={(event) => onClicked(event, id)}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Avatar alt={name} src={name} />
                <Typography variant="subtitle2" noWrap>
                  {name}
                </Typography>
                {ownerId !== user?.id && (
                  <Chip label="Shared" size="small" variant="outlined" color="info" sx={{ ml: 1 }} />
                )}
              </Stack>
            </TableCell>
            <TableCell align="left">{description}</TableCell>
            <TableCell align="left">{getDateString(startTime)}</TableCell>
            <TableCell align="right">{getDateString(lastModified)}</TableCell>
          </TableRow>
        );
      })}
      {emptyRows > 0 && (
        <TableRow style={{ height: 53 * emptyRows }}>
          <TableCell colSpan={6} />
        </TableRow>
      )}
    </TableBody>
  );
}

export default SessionTableBody;
